
import { defineComponent } from "vue"

export default defineComponent({
  props: {
    useDemoOverlay: { type: Boolean, required: true }
  }
})
